// extracted by mini-css-extract-plugin
module.exports = {"errorTitle":"error-message-module--errorTitle--1PLl1","errorSubtitle":"error-message-module--errorSubtitle--10MHc","errorText":"error-message-module--errorText--12Zv6"};